const Dynpack = require('od-apps/app.dynpack');
const CartDetails = require('./js/api/cart_details');
import {dispatch} from 'od-modules/secure_store/store';
const actions = require('od-modules/secure_store/actions');
const PRODUCT_PROFILES = CartDetails.getProfiles();
const PARAMS_BY_PAGE = CartDetails.getParametersByPage();
const ERRORS_BY_PROFILE = CartDetails.getErrorByProfile();
const ERRORS_BY_PAGE = CartDetails.getErrorByPage();

let promiseCart = null;

const getDynpackShoppingCart = () => {
    if (promiseCart === null) {
        const cartDetails = new CartDetails();
        promiseCart = getSearchData()
            .then((searchData) => cartDetails.create(searchData.externalSelectionRequest))
            .then(() => cartDetails, () => cartDetails);
    }
    return promiseCart;
};

const getSearchData = () => {
    // We add Promise wrapper because Dynpack.getSearchData returns $.Deferred
    return new Promise((resolve, reject) => {
        Dynpack.getSearchData().then(resolve, reject);
    });
};

const getShoppingCart = () => getDynpackShoppingCart()
    .then((shoppingCart) => shoppingCart.getDetails());

const updateShoppingCartProduct = (selection) => getDynpackShoppingCart()
    .then((shoppingCart) => shoppingCart.updateProduct(selection));

const confirmShoppingCart = () => getDynpackShoppingCart()
    .then((shoppingCart) => shoppingCart.confirmShoppingCart())
    .then((fetchedDetails) => fetchedDetails && fetchedDetails.shoppingCartDTO || {})
    .then((shoppingCartDTO) => {
        dispatch({type: actions.SET_SHOPPING_CART, entry: shoppingCartDTO});
        return shoppingCartDTO;
    });

const fetchShoppingCartProduct = (profile) => getDynpackShoppingCart()
    .then((shoppingCart) => shoppingCart.fetchProduct(profile));

const getShoppingCartProductParameters = () => getDynpackShoppingCart()
    .then((shoppingCart) => shoppingCart.getDynpackProductParameters());

const getShoppingCartRoomResults = () => getDynpackShoppingCart()
    .then((shoppingCart) => shoppingCart.getRoomResults());

const getShoppingCartDeeplink = () => getDynpackShoppingCart()
    .then((shoppingCart) => shoppingCart.getDynpackDeeplink());

const hasShoppingCartError = (message) => getDynpackShoppingCart()
    .then((shoppingCart) => shoppingCart.hasError(message));

const getShoppingCartErrors = () => getDynpackShoppingCart()
    .then((shoppingCart) => shoppingCart.getErrors());

const removeCart = () => promiseCart = null;

export default {
    getShoppingCart,
    fetchShoppingCartProduct,
    updateShoppingCartProduct,
    confirmShoppingCart,
    hasShoppingCartError,
    getShoppingCartProductParameters,
    getShoppingCartRoomResults,
    getShoppingCartDeeplink,
    getShoppingCartErrors,
    PRODUCT_PROFILES,
    PARAMS_BY_PAGE,
    ERRORS_BY_PROFILE,
    ERRORS_BY_PAGE,
    removeCart,
};
